import { useCallback } from 'react';
import useCloneForm from 'asset-actions-lib-forms/clone/hooks/useCloneForm';
import hydrateFormWithDefaults from 'asset-actions-lib-forms/utils/hydrateFormWithDefaults';
import { PostSubmissionOptions } from 'asset-actions-lib-forms/constants/form';
import { getFormattedDefinition, validateFormByPostSubmissionOption } from 'asset-actions-lib-forms/utils/formSavingUtils';
import usePublishAndDeleteDraft from './usePublishAndDeleteDraft';
export default function useCloneAndTranslateForm() {
  const {
    cloneForm,
    loading: isCloning
  } = useCloneForm();
  const {
    publishAndDeleteDraft,
    loading: isPublishing
  } = usePublishAndDeleteDraft();
  const cloneAndTranslateForm = useCallback(args => {
    return cloneForm(args).then(clonedForm => {
      const hydratedForm = hydrateFormWithDefaults(clonedForm);
      const postSubmissionOption = hydratedForm.redirect ? PostSubmissionOptions.REDIRECT_PAGE : PostSubmissionOptions.THANK_YOU_MESSAGE;
      const {
        valid,
        type
      } = validateFormByPostSubmissionOption({
        formDefinition: hydratedForm,
        postSubmissionOption
      });
      if (!valid) {
        throw new Error('Invalid form', {
          cause: type
        });
      }
      return getFormattedDefinition(postSubmissionOption, hydratedForm, hydratedForm.notifyRecipients ? hydratedForm.notifyRecipients.split(',') : []);
    }).then(formDefinition => publishAndDeleteDraft(formDefinition));
  }, [cloneForm, publishAndDeleteDraft]);
  return {
    cloneAndTranslateForm,
    loading: isPublishing || isCloning
  };
}